<template>
  <c-modal title="Send password reset" :show="show" @update:show="toggle">
    <p class="lead">Please confirm that you would like to send a password reset link to:</p>
    <p class="lead">
      <strong>{{ user.username }}</strong>
    </p>
    <template v-slot:footer>
      <c-button-group>
        <c-button color="primary" @click="resetPasswordRequest">
          <c-spinner v-if="isSendingPasswordReset" color="success" size="sm" />
          <span v-else>Send password reset</span>
        </c-button>
        <c-button v-if="!isSendingPasswordReset" color="secondary" @click="close">Cancel</c-button>
      </c-button-group>
    </template>
  </c-modal>
</template>

<script>
import { buildEndpoint } from '@/libs/buildEndPoint';

export default {
  props: {
    user: Object,
    show: Boolean,
  },
  data() {
    return {
      error: null,
      isSendingPasswordReset: false,
    };
  },
  created() {},
  methods: {
    toggle(event) {
      if (!event) {
        this.$emit('close');
      }
    },
    close() {
      this.$emit('close');
    },
    resetPasswordRequest() {
      this.isSendingPasswordReset = true;
      const data = {
        username: this.user.username,
      };
      this.$http
        .post(buildEndpoint('password/reset/generate'), data)
        .then((response) => {
          this.isSendingPasswordReset = false;
          if (response.data.success) {
            this.$store.commit('addSuccessMessage', {
              header: 'Success',
              message: `Password reset link set to ${this.user.username}`,
            });
            this.close();
          } else {
            this.$store.commit('addErrorMessage', {
              header: 'Error',
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.error = error;
          this.$store.commit('addErrorMessage', {
            header: 'Error',
            message: error,
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
